<template>
  <div class="tax">
    <div class="first_g" v-if="showFirst" @click="clickLogin"></div>
    <div v-if="!showFirst" class="tax_wrap">
      <tax />
    </div>
  </div>
</template>

<script setup>
import { useTaxStore } from "@/store/modules/tax.js";
import tax from "./components/tax.vue";
import { storeToRefs } from "pinia";
import {setLoginInfo, isAlReadyLogin} from "@/views/examCenter/tax/taxLoginHandler.js";
const taxStore = useTaxStore();
const showFirst = ref(true);
const route = useRoute();
const props = defineProps({
  currentQa: {
    type: Object,
    default: () => {},
  },
});
const { saveSolution, personCollectionList } = storeToRefs(taxStore);
onMounted(() => {
  if(isAlReadyLogin()) {
    showFirst.value = false
  }
  saveSolution.value = props.currentQa.solution
      ? JSON.parse(props.currentQa.solution)
      : null;
  taxStore.setAcceptInfo({ ...props.currentQa });

  // 直接用通用缓存的(总体保持一致，改一个动全部，但一旦为null，说明缓存丢失，不覆盖)
  const commonData = sessionStorage.getItem('taxPersonCommonList' + route.query.id)
  if (commonData != null) {
    personCollectionList.value = JSON.parse(commonData)
  }
});
const getGrandchildValue = inject("getGrandchildValue");
getGrandchildValue.value.getData = () => {
  return {
    solution: (saveSolution.value && JSON.stringify(saveSolution.value)) || "",
  };
};
getGrandchildValue.value.getResetData = () => {
  taxStore.reset();
  return {
    solution: "",
  };
};

function clickLogin() {
  setLoginInfo()
  showFirst.value = !showFirst.value
}
</script>

<style lang="scss" scoped>
.tax {
  height: 100%;
  .first_g {
    height: 100%;
    background: url(https://static.rhkj.com/renhe_fe/other/tax/win_bg.png);
    background-size: cover;
    background-position: 50% 50%;
  }
  .tax_wrap {
    height: 100%;
  }
}
</style>
